<template>
  <section class="pt-40 pb-20 md:pt-48 md:pb-32 px-6 relative overflow-hidden">
    <!-- Background Decor -->
    <div
      class="absolute top-0 right-0 w-[500px] h-[500px] bg-rose-50 rounded-full blur-3xl opacity-50 -z-10 translate-x-1/2 -translate-y-1/2"
    ></div>

    <div class="max-w-7xl mx-auto text-center">
      <span
        class="inline-block py-1 px-3 rounded-full bg-gray-100 text-gray-600 text-xs font-bold tracking-wider mb-6 animate-fade-in-up"
        style="animation-delay: 0.1s"
      >
        2026 全新一代電商解決方案
      </span>
      <h1
        class="text-5xl md:text-7xl font-black text-gray-900 mb-8 leading-tight animate-fade-in-up"
        style="animation-delay: 0.2s"
      >
        讓銷售變得<br /><span
          class="text-transparent bg-clip-text bg-gradient-to-r from-brand to-rose-400"
          >簡單又優雅</span
        >
      </h1>
      <p
        class="text-lg md:text-xl text-gray-500 max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in-up"
        style="animation-delay: 0.3s"
      >
        快樂買購物系統專為高轉換率設計。整合「一頁式結帳」、「優惠系統」與「行銷模組」，打造如精品般的購物體驗。
      </p>
      <div
        class="flex flex-col sm:flex-row justify-center gap-4 animate-fade-in-up"
        style="animation-delay: 0.4s"
      >
        <button
          class="px-8 py-4 bg-primary text-white rounded-full font-bold text-lg hover:bg-gray-800 shadow-xl transition-all hover:-translate-y-1"
        >
          立即預約試用
        </button>
        <button
          class="px-8 py-4 bg-white border border-gray-200 text-gray-700 rounded-full font-bold text-lg hover:bg-gray-50 transition-colors flex items-center justify-center gap-2"
        >
          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
            ></path>
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          觀看影片介紹
        </button>
      </div>
    </div>

    <!-- Hero Image (Mockup) -->
    <div
      class="mt-20 relative max-w-5xl mx-auto animate-fade-in-up"
      style="animation-delay: 0.6s"
    >
      <div
        class="mockup-browser bg-white border border-gray-200 overflow-hidden animate-float"
      >
        <div class="mockup-header">
          <div class="dot bg-red-400"></div>
          <div class="dot bg-yellow-400"></div>
          <div class="dot bg-green-400"></div>
          <div
            class="ml-4 bg-white px-4 py-1 rounded text-xs text-gray-400 flex-1 text-center"
          >
            kolshop.com.tw
          </div>
        </div>
        <!-- 嵌入一張模擬的系統截圖 -->
        <div class="bg-gray-50 aspect-video relative group overflow-hidden">
          <img
            src="/img/website.png"
            class="w-full h-full object-cover opacity-90"
          />
          <div class="absolute inset-0 flex items-center justify-center">
            <div
              class="bg-white/90 backdrop-blur-md p-8 rounded-2xl shadow-2xl text-center max-w-sm transform group-hover:scale-105 transition-transform duration-500"
            >
              <div
                class="w-16 h-16 bg-brand rounded-full flex items-center justify-center mx-auto mb-4 text-white"
              >
                <svg
                  class="w-8 h-8"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>
              <h3 class="text-xl font-bold mb-2">訂單已成立</h3>
              <p class="text-sm text-gray-500">
                極速結帳體驗，<br />從瀏覽到下單只需 30 秒。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
};
</script>
